import {DisposalSet, select} from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import './styles.scss';

const gc = new DisposalSet();

registerFragment('chroa-chip', (fragmentEl, config, meta) => {
    const outerFrag = fragmentEl.parentElement;
    const removeBtnEl = select<HTMLButtonElement>(fragmentEl, '.chroa-chip__remove');
    const remove = document.createElement('div');
    (gc.register(removeBtnEl)
        .addListener('click', () => {
            if (outerFrag) outerFrag.remove();
        })
    );
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
